import { spawn } from 'redux-saga/effects';

import infoSagas from './info/infoSagas';

export default function* sagas() {
	yield spawn(infoSagas);
}
